// extracted by mini-css-extract-plugin
module.exports = {"container":"Authentication_container__1ly5K","red":"Authentication_red__Lb9We","modal":"Authentication_modal__XqVzi"};